import noUiSlider from 'nouislider';

/**
 * @param  {HTMLElement} slider e slider to manipulate
 * @param  {Number} i index
 * @param  {Number} value slider value to set
 * @return {void}
 */
function setSliderHandle(slider, i, value) {
  const r = [null, null];
  r[i] = value;
  slider.noUiSlider.set(r);
}

/**
 * @param  {HTMLElement} slider slider element
 * @return {Boolean} true
 */
function createRangeSlider(slider) {
  const parent = slider.parentElement;
  const inputMin = parent.querySelector('[data-min-input]');
  const inputMax = parent.querySelector('[data-max-input]');
  const inputs = [inputMin, inputMax];

  if (inputMin === null || inputMax === null) return false;

  noUiSlider.create(slider, {
    start: [parseInt(inputMin.value, 10), parseInt(inputMax.value, 10)],
    step: parseInt(inputMin.step, 10),
    margin: parseInt(inputMin.step, 10),
    range: {
      min: parseInt(inputMin.min, 10),
      max: parseInt(inputMin.max, 10),
    },
  });

  slider.noUiSlider.on('update', (values, handle) => {
    const input = inputs[handle];

    // Make sure the updated value is an integer
    input.value = values[handle].split('.')[0];

    const inputNameTokens = input.name.split('_');

    // Is this is a filter range slider?
    if (inputNameTokens.length === 3
      && (inputNameTokens[0] === 'f'
      && (inputNameTokens[2] === 'min' || inputNameTokens[2] === 'max'))) {
      // Is there a matching filter-active flag input field?
      const filterActiveName = `f_${inputNameTokens[1]}_active`;
      const filterActiveFlag = document.querySelector(`[name="${filterActiveName}"]`);

      // We only need to check min/max to adjust the active flag
      // if we really have one and if it was not set to "1" in the first place
      if (filterActiveFlag != null
        && filterActiveFlag.dataset.initialValue === '0') {
        // Check if the integer value of the min and/or max input field was changed
        // compared to the initial value of the input field.
        // We need both input fields. We assume we're currently on "min" first
        let otherInputName = `f_${inputNameTokens[1]}_max`;
        if (inputNameTokens[2] === 'max') {
          // No, we're on max
          otherInputName = `f_${inputNameTokens[1]}_min`;
        }
        const otherInput = document.querySelector(`[name="${otherInputName}"]`);

        if (otherInput != null) {
          // Check if at least one of the range filter values were changed by the user
          if (input.value !== input.dataset.initialValue
            || otherInput.value !== otherInput.dataset.initialValue) {
            filterActiveFlag.value = 1;
          } else {
            filterActiveFlag.value = 0;
          }
        }
      }
    }
  });

  // Listen to keydown events on the input field.
  inputs.forEach((input, handle) => {
    input.addEventListener('change', (event) => {
      setSliderHandle(slider, handle, event.target.value);
    });
  });

  return true;
}

/**
 * @param  {HTMLElement} scope = document
 * @return {void}
 */
export default function initRangeSliders(scope = document) {
  const rangeSlider = [].slice.call(scope.querySelectorAll('[data-range-slider]'));

  if (rangeSlider !== null) {
    rangeSlider.forEach((slider) => {
      createRangeSlider(slider);
    });
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/range.js